import { omit } from 'lodash'

/**
 * Query keys that must NOT be sent on Consignee/Shipper aggregate download
 * requests. The Lighthouse aggregate UI fetches a single capped list (size =
 * MAX_AGGREGATE_COUNT) and paginates client-side — see
 * fetchAggregatedConsignees / fetchAggregatedShippers, which already delete
 * `page` and `limit` before calling the API.
 *
 * Shipment-hit search pagination keys (`page`, `limit`, `customFrom`,
 * `customSize`) are part of the generic search criteria builder, but if they
 * leak into the aggregate download request they can change the ES query
 * window — terms-aggregation order and bucket counts would no longer match
 * what the UI showed, so download rows would not line up with UI rows for
 * ranges like 15–35.
 *
 * Keep the list in sync with isng-export-service `chalicelib/services/export.py`,
 * which pops the same keys before forwarding the aggregate request to the
 * search service.
 *
 * Note: the default Shipments results table is downloaded via the `search`
 * type (not the aggregate types). That path uses customFrom/customSize and is
 * intentionally left alone.
 */
export const AGGREGATE_DOWNLOAD_EXCLUDED_PARAM_KEYS = [
  'page',
  'limit',
  'customFrom',
  'customSize'
]

export function stripAggregateDownloadPaginationKeys(criteria) {
  return omit(criteria, AGGREGATE_DOWNLOAD_EXCLUDED_PARAM_KEYS)
}
